import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=5025a2d6&scoped=true"
import script from "./project-list.vue?vue&type=script&lang=js"
export * from "./project-list.vue?vue&type=script&lang=js"
import style0 from "./project-list.vue?vue&type=style&index=0&id=5025a2d6&prod&lang=scss"
import style1 from "./project-list.vue?vue&type=style&index=1&id=5025a2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025a2d6",
  null
  
)

export default component.exports